import { render, staticRenderFns } from "./SplitBanner.vue?vue&type=template&id=944c0dee&scoped=true"
import script from "./SplitBanner.vue?vue&type=script&lang=js"
export * from "./SplitBanner.vue?vue&type=script&lang=js"
import style0 from "./SplitBanner.vue?vue&type=style&index=0&id=944c0dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944c0dee",
  null
  
)

export default component.exports